module.exports = __webpack_public_path__ + "static/card-water-land-2-9193657ffe8de4e960fed71f22f464ce.jpg";